import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CustomFieldTypePipe } from '../../../pipes/custom-field-type.pipe';

@Component({
  selector: 'app-custom-field-number',
  standalone: true,
  templateUrl: './custom-field-number.component.html',
  imports: [MatFormField, MatInput, ReactiveFormsModule, MatHint, CustomFieldTypePipe],
  styleUrl: './custom-field-number.component.scss'
})
export class CustomFieldNumberComponent {
  @Input() group: FormGroup | null = null;
  @Input() showHint = false;
}
